import { Empty, Button, Modal, Table, Col, Collapse, Input } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import React,{ useEffect, useState } from "react";
import Formulario from "../Formulario";
import PortalTable from "./SubComponents/PortalTable";
import { StyledForm } from "../styles";
import FormInputDivider from "./FormInputDivider";
import ArrayUtils from "utils/arrays";
import { spanDeCampoObrigatorio, styleCollapse } from "./styles";
import ObjectUtils from "utils/objects";
import { NotificationManager } from "react-notifications";
import { MessagesDefaultTimeout } from "constants/messagesDefaultTimeout";

function PortalInputTable ({ input, divider, form, colSpan, containerSettings, onValuesChange, ...props }) {
    const [dadosExistentes, setDadosExistentes] = useState([]);
    const [dadosSelecionados, setDadosSelecionados] = useState([]);
    const [inputError, setInputError] = useState('')
    const [showModal, setShowModal] = useState(false);
    const childRef = React.useRef(null);
    const [childFormRef] = StyledForm.useForm();
    
    useEffect(()=>{
        setDadosExistentes(props?.dataSource)
        setDadosSelecionados(props?.dataSource ?? [])
    },[])

    useEffect(()=>{
        var dadosDoCampoNoFormulario = form.getFieldValue(input.name) || [];
        
        if(!ArrayUtils.arraysAreEqual(dadosSelecionados, dadosDoCampoNoFormulario)){
            form.setFieldsValue({ [input.name]: dadosSelecionados });
            if (onValuesChange) {
                onValuesChange({ [input.name]: dadosSelecionados }, form.getFieldsValue());
            }
        }
    },[dadosSelecionados])
    
    const handleAdd = async (novoItem) =>{
        childFormRef.resetFields();

        setDadosExistentes(prev => {
            const exists = prev.some(item => ObjectUtils.objetosSaoIguais(item,novoItem));
            return exists ? prev : [...prev, novoItem];
        });
        setDadosSelecionados(prev => {
            const exists = prev.some(item => ObjectUtils.objetosSaoIguais(item,novoItem));
            return exists ? prev : [...prev, novoItem];
        });
    }

    const handleAddMultiple = (items) =>{
        setDadosExistentes((prev) =>{
            const filteredItems = ArrayUtils.getAddedItems(prev, items);
            return [...prev, ...filteredItems];
        })
        setDadosSelecionados(items);
        setShowModal(false);
    }

    const handleRemove = (itemToRemove) =>{
        setDadosSelecionados(prev => prev.filter(item => !ObjectUtils.objetosSaoIguais(item,itemToRemove)));
        setDadosExistentes(prev => prev.filter(item => !ObjectUtils.objetosSaoIguais(item,itemToRemove)));
    }

    const RenderizarTabelaPrincipal = () =>{
        const isTableType = props.container?.containerSettings.content.contentType === "table";
        const columnsWithActions = !isTableType
            ? [
                ...props.columns,
                {
                title: '',
                key: 'acoes',
                width: 10,
                render: (_, record) => (
                    <Button
                    type="link"
                    danger
                    icon={<DeleteOutlined />}
                    onClick={() => handleRemove(record)}
                    />
                ),
                },
            ]
        : props.columns;
        const rowSelection = isTableType
        ? {
            type: "checkbox",
            selectedRowKeys: dadosSelecionados.map(r => r.key),
            onChange: (selectedRowKeys, selectedRows) => { 
                setDadosSelecionados(selectedRows),
                form.validateFields([input.name]).catch((error) => {}) },
            columnTitle: '',
            hideSelectAll: true 
        }
        : undefined;

        return (
            <>
                <Button
                    onClick={() => setShowModal(true)}
                    type="primary"
                    style={{ marginBottom: '16px' }}
                >
                    {props.container?.tituloBotao ?? "Adicionar"}
                </Button>
                <Table
                    dataSource={dadosExistentes}
                    columns={columnsWithActions}
                    rowSelection={rowSelection}
                    pagination={{showTotal:(total) => `Selecionados: ${dadosSelecionados.length} Total: ${total}` }}
                    tableLayout="auto"
                    size="small"
                    scroll={dadosExistentes.length > 0 ? { y: 275 } : undefined}
                    locale={{ emptyText: <Empty description={'Sem dados'} image={Empty.PRESENTED_IMAGE_SIMPLE} /> }}
                />
            </>
        )
    }
    
    const TabelaPrincipalDentroDoCollapse = [
        {
          key: 1,
          label: <>{spanDeCampoObrigatorio(input?.rules)}{input.label}</>,
          children: RenderizarTabelaPrincipal()
        }
    ];

    const RenderizarInput = () =>{
        return(
            <StyledForm.Item {...input} extra={props.helpMessage} hidden={true} label={props.collapse ? "" : input.label}
                rules={[...(input?.rules || []),
                ({isFieldTouched}) =>({
                  validator(_, value){
                    if (!isFieldTouched(input.name)) return Promise.resolve();
                    if(input?.rules?.some(rule => rule.required)){
                      if(dadosSelecionados.length == 0){
                        setInputError(input?.rules?.message ?? "Campo obrigatório");
                        return Promise.reject(input?.rules?.message ?? "Campo obrigatório")
                      }
                    }
                    setInputError('');
                    return Promise.resolve();
                  }
                })
              ]}>
                <Input disabled={input?.disabled} addonBefore={input?.addonBefore} addonAfter={input?.addonAfter} hidden={true}/>
            </StyledForm.Item>
        )
    }
    
    const modalHandleOk = async () =>{
        var content = props.container.containerSettings.content;
        
        if (content.contentType == "table"){
            childRef.current.setSelectedPage(1);
            const selectedItems = childRef.current.getSelected() ?? [];
            handleAddMultiple(selectedItems);
        }else{
           childFormRef.submit();
        }
    }
    const modalHandleClose = () =>{
        setShowModal(false);
        if(childRef.current){
            childRef.current.setSelectedPage(1);
        }
    }

    const renderizarModalContent = () => {
        var content = props.container.containerSettings.content;
        if (content.contentType == "table"){
            return(
                <div>
                    <PortalTable
                        content={content} 
                        ref={childRef}
                        initialValuesSelectedRows={dadosSelecionados}
                    />
                </div>
            )
        }
        else if (content.contentType == "customForm"){
            return React.cloneElement(content.formCustomComponent, 
                {formRef: childFormRef, dadosAdicionados: dadosSelecionados, onFinish: formularioOnFinish, onFinishFailed: formularioOnFinishFailed, ...content.props})
        }   
        else{
            return(   
                <Formulario             
                    inputsData={content.inputs}
					formReference={childFormRef}
                    hideSubmitButton={true}
                    onFinish={formularioOnFinish}
                    onFinishFailed={formularioOnFinishFailed}
                />
            )
        }
    }

    const formularioOnFinish = async () => {
        handleAdd(childFormRef.getFieldsValue());
        setShowModal(false);
    }

    const formularioOnFinishFailed = async () => {
        NotificationManager.error('Por favor preencha todos os dados corretamente.', 'Formulário incompleto!', MessagesDefaultTimeout.Error);
    }

    return (
        <FormInputDivider key={input.name} {...divider}>
                <Col span={colSpan ? colSpan : (props.inputColSpan? props.inputColSpan : 24)} key={input.name} style={{backgroudColor: "#FF0000"}}>
                    <Col span={input?.colSpan ? input.colSpan : 24} style={{padding:"0px"}}>
                        {RenderizarInput(input?.rules)}
                        {props.collapse 
                            ? 
                                <div style={{marginBottom:'8px'}}>
                                    <div ref={props?.collapse?.ref}>
                                    <Collapse items={TabelaPrincipalDentroDoCollapse} 
                                        defaultActiveKey={[props.collapse?.open ? 1 : 0]} 
                                        style={styleCollapse(!!inputError)}/>
                                    </div>
                                </div>
                            :
                            <>    
                                {RenderizarTabelaPrincipal()}
                            </>
                        }
                        {inputError ? <span style={{color: '#ff4d4f'}}>{inputError}</span> : ""}
                        <Modal 
                            title={props.container?.tituloBotao ?? "Adicionar"} 
                            open={showModal} 
                            onOk={modalHandleOk} 
                            onCancel={modalHandleClose} 
                            width={800}
                        >
                            {renderizarModalContent(props.container)}
                        </Modal>
                    </Col>
                </Col>
        </FormInputDivider>
    );

}

export default PortalInputTable;